import { useContext, useEffect } from 'react';

import { SocketContext } from '@/contexts/rtm';
import { SocketEvent } from '@/shared/types/rtm';

export const useRtmGuidelines = (brainId: string | undefined) => {
  const { socket, isConnected } = useContext(SocketContext);

  useEffect(() => {
    if (!socket || !brainId || !isConnected) {
      return;
    }

    socket.emit(SocketEvent.guidelines_viewing, { brain_id: brainId });

    return () => {
      socket.emit(SocketEvent.guidelines_viewing_stop, { brain_id: brainId });
    };
  }, [isConnected, brainId, socket]);
};
